<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <!-- <g fill="none">
      <path 
        d="M6 3v18M6 3l4 4M6 3L2 7" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
      <path 
        d="M18 21V3m0 18l4-4m-4 4l-4-4" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
    </g> -->
    <path 
      d="M11.95 7.95l-1.414 1.414L8 6.828V20H6V6.828L3.465 9.364L2.05 7.95L7 3l4.95 4.95zm10 8.1L17 21l-4.95-4.95l1.414-1.414l2.537 2.536L16 4h2v13.172l2.536-2.536l1.414 1.414z" 
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'arrow-up-down',
}
</script>
